import { EHRProvider } from '@heidi/schema/ml-scribe';

// Maps a legacy provider to its new-framework equivalent.
// Magentus → Gentu (migration complete; previously gated by release-magentus-new-framework).
export const resolveOnboardingProvider = (ehrProvider: EHRProvider): EHRProvider => {
  if (ehrProvider === EHRProvider.Magentus) {
    return EHRProvider.Gentu;
  }
  return ehrProvider;
};
